import { render, staticRenderFns } from "./CustomerWork.vue?vue&type=template&id=325d208e"
import script from "./CustomerWork.vue?vue&type=script&lang=js"
export * from "./CustomerWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports